import React from 'react';
import StockKeywordAnalyzer from '../../components/Admin/StockKeywordAnalyzer';

const StockKeywordPage = () => {
  return (
    <div className="admin-page">
      <StockKeywordAnalyzer />
    </div>
  );
};

export default StockKeywordPage;
